import React, {useContext} from "react";
import {Fade} from "react-reveal";
import emoji from "react-easy-emoji";
import "./Greeting.scss";
import landingPerson from "../../assets/lottie/landingPerson";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import {illustration, greeting} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

export default function Greeting() {
  const {isDark} = useContext(StyleContext);
  if (!greeting.displayGreeting) {
    return null;
  }
  
  // Split subtitle into sentences and make the last one bold and underlined
  const renderSubtitle = () => {
    const subTitle = greeting.subTitle;
    if (!subTitle) return null;
    
    // Split by periods followed by space (more compatible approach)
    const sentences = subTitle.split(/\.\s+/);
    if (sentences.length <= 1) {
      return <strong className="bold-underline">{subTitle}</strong>;
    }
    
    // Get the last sentence and add the period back if it was removed
    const lastSentence = sentences[sentences.length - 1];
    // Join other sentences with periods and spaces
    const otherSentences = sentences.slice(0, -1).join(". ") + ".";
    
    return (
      <>
        {otherSentences}{" "}
        <strong className="bold-underline">{lastSentence}</strong>
      </>
    );
  };
  
  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1
                className={isDark ? "dark-mode greeting-text" : "greeting-text"}
              >
                {" "}
                {greeting.title}{" "}
                <span className="wave-emoji">{emoji("👋")}</span>
              </h1>
              <p
                className={
                  isDark
                    ? "dark-mode greeting-text-p"
                    : "greeting-text-p subTitle"
                }
              >
                {renderSubtitle()}
              </p>
              <div id="resume" className="empty-div"></div>
              <SocialMedia />
              <div className="button-greeting-div">
                <Button text="Contact me" href="#contact" />
                {greeting.resumeLink && (
                  <a
                  href={require("./selina_resume.pdf")}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="download-link-button"
                >
                  <Button text="View my resume" />
                </a>                
                )}
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            {illustration.animated ? (
              <DisplayLottie animationData={landingPerson} />
            ) : (
              <img
                alt="man sitting on table"
                src={require("../../assets/images/headshot.png")}
              ></img>
            )}
          </div>
        </div>
      </div>
    </Fade>
  );
}
